module.exports = __webpack_public_path__ + "static/media/icon-stage-milestone-black.a0207de1.svg";